const Comment = () =>
  import(/* webpackChunkName: "blog-comment" */ '@/pages/blog/blog/comment/index.vue')

const CreateComment = () =>
  import(
    /* webpackChunkName: "blog-comment" */ '@/pages/blog/blog/comment/create.vue'
  )
const EditComment = () =>
  import(
    /* webpackChunkName: "blog-comment" */ '@/pages/blog/blog/comment/edit.vue'
  )

export default {
  path: 'comment',
  meta: {
    label: 'comment',
    auth: 'comment'
  },
  component: {
    name: 'Comment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogCommentReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Comment
    },
    {
      name: 'BlogCreateComment',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateComment
    },
    {
      name: 'BlogEditComment',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditComment,
      props: true
    }
  ]
}
